import { XIcon } from '@auth0/quantum-product';
import * as React from 'react';
import { CloseIconButton } from './styled';
export var CloseButton = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(CloseIconButton, { variant: "contained", "aria-label": "Close", size: "small", onClick: onClick },
        React.createElement(XIcon, null)));
};
